module.exports = __webpack_public_path__ + "static/media/data-process.ca04e3bd.svg";